// ECharts dạng "core": chỉ đăng ký phần trang Phân tích dùng (bundle nhẹ hơn nhập cả `echarts`).
// Lịch heatmap tháng KHÔNG dùng echarts — lưới div 7 cột (components/month-heatmap.tsx).

import { createElement } from 'react';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkPointComponent,
  TooltipComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import type { EChartsReactProps } from 'echarts-for-react/lib/types';

echarts.use([
  LineChart,
  BarChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  MarkPointComponent,
  DataZoomComponent,
  CanvasRenderer,
]);

/** Bảng màu dùng chung các biểu đồ (theo theme/tokens: accent, lilac, sun, info, peach, success). */
export const CHART_COLORS = [
  '#C2337D',
  '#8E97FD',
  '#E8B04B',
  '#1F5FA8',
  '#FEA88C',
  '#0F7A46',
  '#9A8F9E',
];

export const AXIS_TEXT = '#6B6272';
export const GRID_LINE = '#ECE4E9';

type Props = Omit<EChartsReactProps, 'echarts'>;

/** Bọc ReactEChartsCore với `echarts` đã đăng ký; mặc định notMerge để đổi chuỗi không dính dữ liệu cũ.
 *  (File .ts theo kế hoạch nên dùng createElement thay JSX.) */
export const ReactECharts = (props: Props) =>
  createElement(ReactEChartsCore, { echarts, notMerge: true, lazyUpdate: true, ...props });

export default ReactECharts;
